import { TableRowExpansionEvent } from "@mcleod/components";
import { AutogenLayoutTieredStopChargesTableList } from "./autogen/AutogenLayoutTieredStopChargesTableList";
import { AutoRateLookup } from "./AutoRateLookup";

export class TieredStopChargesTableList extends AutogenLayoutTieredStopChargesTableList  {
    tableTieredStopChargesTablesOnRowExpand(event: TableRowExpansionEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const tableId = modelRow.getString("table_id");
        const autoRateLookup = event.expandComponents.find(c => c instanceof AutoRateLookup);
        autoRateLookup.sourceRateLookup.search({ "tiered_table": tableId });
    }
}